export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2025-01-16T18:28:34.737Z",
    "Last-Translator": "",
    "Language-Team": "",
    "Language": "en-US",
    "Messages": {
        ".": "",
        "...": "...",
        "2 dni": "2 days",
        "2 miesiące": "2 months",
        "2 tygodnie": "2 weeks",
        "3 dni": "3 days",
        "3 miesiące": "3 months",
        "4 dni": "4 days",
        "5 dni": "5 days",
        "6 dni": "6 days",
        "Aby skonfigurować wysyłkę, należy uzułenić wymagane pola.": "",
        "Adres": "Address",
        "Adres email": "",
        "Adres email jest pusty.": "",
        "Adres email odbiorcy": "",
        "Adres URL": "URL address",
        "Akcent": "Accent",
        "Akceptacja": "Approval",
        "Akceptacja dokumentów": "Document approval",
        "Akceptacja dokumentu": "Document approval",
        "Akceptacja własnych dokumentów": "Approval of own documents",
        "Akceptacja wszystkich dokumentów": "Approval of all documents",
        "Akceptowalny typ plików": "Acceptable file type",
        "Akceptowany format danych": "Acceptable data format",
        "Akceptuj": "Accept",
        "Akcje": "Actions",
        "Akordeon": "Accordion",
        "Aktualizacja definicji": "Definition update",
        "Aktualizacja dokumentu": "",
        "Aktualizacja encji": "",
        "Aktualizacja wpisu": "Entry update",
        "Aktualizowane pola": "",
        "Aktualizuj": "Update",
        "Aktywna": "Active",
        "Aktywne": "Active",
        "Aktywny": "Active",
        "Ankieta": "Survey",
        "Anonimizacja": "",
        "Anonimowy": "Anonymous",
        "Anulowany": "Canceled",
        "Anuluj": "Cancel",
        "Aplikacja": "Application",
        "application/json": "application/json",
        "application/x-www-form-urlencoded": "application/x-www-form-urlencoded",
        "Audio": "Audio",
        "Automatyzacja": "Automation",
        "Baza danych": "Database",
        "Bazowy model danych": "Base data model",
        "Bezpieczeństwo": "Security",
        "Bieżący dokument": "Current document",
        "Widget służy do budowania obiektu z wybranych wartości.": "",
        "Widget służy do parsowania szablonów w języku Liquid.": "",
        "Widget służy do renderowania MJML na HTML": "",
        "Widget umożliwia przygotowanie dowolnego skryptu w języku C#.": "",
        "Widget wyzwala scenariusz po wykonaniu akcji wybranej w polu": "",
        "Widget zwracana wybrany szablon wiadomości email.": "",
        "Błąd": "Error",
        "Błędne": "Invalid",
        "Błędny": "Invalid",
        "Błędy walidacji należy przypisać do \"entry.errors.value\" w postaci tablicy komunikatów.": "Validation errors must be assigned to \"entry.errors.value\" as an array of messages.",
        "Bool": "Bool",
        "brak": "",
        "Brak": "None",
        "Brak danych": "No data",
        "Brak dodanych kolumn": "No columns added",
        "Brak drugiej wersji do porównania": "No second version to compare",
        "Brak odpowiedzi": "No answer",
        "Brak różnic między wybranymi wersjami": "No differences between the selected versions",
        "Brak właściwości do konfiguracji.": "",
        "brak wyboru...": "no selection...",
        "Brak wyników": "No results",
        "Build": "Build",
        "Cache": "Cache",
        "Cache będzie przechowywany z wykorzystaniem serwera Redis.": "Cache will be stored using Redis server.",
        "Cache po stronie serwera": "Server-side cache",
        "Cache-Control": "Cache-Control",
        "Cechy": "Features",
        "Checkbox": "Checkbox",
        "Ciemny": "Dark",
        "Cyfry": "Digits",
        "Czas pomiędzy": "Time between",
        "Czas rozpoczęcia": "Start time",
        "Czas trwania": "Duration",
        "Czas trwania: %0": "Duration: %0",
        "Czas zakończenia": "End time",
        "Cztery kolumny": "Four columns",
        "Czy na pewno chcesz zaktualizować definicje wszystkich dokumentów?": "Are you sure you want to update the definitions of all documents?",
        "Dalej": "Next",
        "Dane": "Data",
        "Dane formularza są przechowywane w obiekcie Entry.": "Form data is stored in the Entry object.",
        "Dane odbiorcy": "",
        "Dane osobowe": "Personal data",
        "Dane tabelaryczne": "Tabular data",
        "Dane techniczne": "Technical data",
        "Dane z formularza zapisywane anonimowo": "Form data saved anonymously",
        "Data": "Date",
        "Data dodania": "Date added",
        "Data i czas": "Date and time",
        "Data rozpoczęcia": "Start date",
        "Data rozpoczęcia publikacji": "Publication start date",
        "Data wywołania": "Call date",
        "Data zakończenia": "End date",
        "Data zakończenia publikacji": "Publication end date",
        "Data: %0 | Autor: %1 | Status: %2": "Date: %0 | Author: %1 | Status: %2",
        "Data: %0 | Status: %1": "Date: %0 | Status: %1",
        "DateTime": "DateTime",
        "Dedykowane": "Dedicated",
        "Definicja": "Definition",
        "Definicja (JSON)": "Definition (JSON)",
        "Definicja formularza znajduje się w obiekcie Form.": "Form definition is in the Form object.",
        "Definicje": "",
        "Definicje zostały zaktualizowane.": "Definitions have been updated.",
        "DELETE: Usunięcie wpisu": "DELETE: Entry deletion",
        "Design Studio": "Design Studio",
        "Diagram": "Diagram",
        "Diagram jest nieprawidłowy, nie zawiera żadnego wyzwalacza.": "",
        "Diagram jest nieprawidłowy, zawiera więcej niż jeden wyzwalacz.": "",
        "Diagram jest nieprawidłowy. Akcja \"%0 (%1)\" jest elementem dwóch różnych pętli.": "",
        "Diagram jest nieprawidłowy. Akcja \"%0 (%1)\" nie posiada rodzica.": "",
        "Diagram jest nieprawidłowy. Jedna ze ścieżek zawiera niezgodną liczbę początków i zakończeń pętli.": "",
        "Diagram jest nieprawidłowy. Jedna ze ścieżek zawiera zagnieżdżone pętle.": "",
        "dla wybranego modelu danych.": "",
        "dla wybranego modułu dynamicznego.": "",
        "Długość czasu przechowywania": "Retention period",
        "Długość geograficzna": "Longitude",
        "do": "to",
        "Do": "To",
        "Dodaj": "Add",
        "Dodaj dni": "Add days",
        "Dodaj dokument": "Add document",
        "Dodaj element": "Add item",
        "Dodaj endpoint": "Add endpoint",
        "Dodaj formularz": "Add form",
        "Dodaj grupę": "Add group",
        "Dodaj kategorię": "Add category",
        "Dodaj komponent": "Add component",
        "Dodaj moduł": "Add module",
        "Dodaj nową wersję dokumentu": "Add new document version",
        "Dodaj obraz": "",
        "Dodaj parametr": "Add parameter",
        "Dodaj podsumowanie": "Add summary",
        "Dodaj pole": "",
        "Dodaj pozycję": "Add position",
        "Dodaj punkt": "Add point",
        "Dodaj scenariusz": "Add scenario",
        "Dodaj sekcję": "Add section",
        "Dodaj stronę": "Add page",
        "Dodaj warunek": "",
        "Dodaj webhooka": "Add webhook",
        "Dodaj wiersz": "Add row",
        "Dodaj wpis": "Add entry",
        "Dodaj wydarzenie": "Add event",
        "Dodaj źródło": "Add source",
        "Dodane": "Added",
        "Dodane przez": "",
        "Dodanie endpointu": "Adding endpoint",
        "Dodanie komponentu": "Adding component",
        "Dodanie modułu": "Adding module",
        "Dodanie webhooka": "Adding webhook",
        "Dodanie źródła danych": "Adding data source",
        "Dodano": "Added",
        "Dodano za dużo plików (maksymalnie %0).": "Too many files added (maximum %0).",
        "Dodatkowe pola do wyszukiwarki": "",
        "Dodawanie": "Adding",
        "Dodawanie dokumentów": "Adding documents",
        "Dodawanie i edycja własnych dokumentów": "Adding and editing own documents",
        "Dodawanie wartości dwóch kolumn": "Adding values of two columns",
        "Dokument": "Document",
        "Dokument został usunięty.": "Document has been deleted.",
        "Dokumenty": "Documents",
        "Dołączanie plików": "Attaching files",
        "Domyślna wartość": "Default value",
        "Domyślnie ukryte": "Hidden by default",
        "Domyślnie widoczne": "Visible by default",
        "Domyślny": "Default",
        "Dopuść brak odpowiedzi": "Allow no answer",
        "Dostęp do modułu": "Module access",
        "Double": "Double",
        "dowolnej wybranej wersji": "any selected version",
        "Dowolny": "Any",
        "Dozwolone rozszerzenia": "Allowed extensions",
        "Dozwolone rozszerzenia plików": "Allowed file extensions",
        "Dozwolone są tylko małe i duże litery": "Only lowercase and uppercase letters are allowed",
        "Dozwolone są tylko małe litery i znak -": "Only lowercase letters and the - character are allowed",
        "Drugie imię": "Middle name",
        "Duże litery": "Uppercase letters",
        "Duży": "Large",
        "Duży układ siatki": "Large grid layout",
        "Dwie kolumny": "Two columns",
        "Dyrektywa max-age=N wskazuje, że odpowiedź pozostaje świeża do N sekund po wygenerowaniu odpowiedzi.": "The max-age=N directive indicates that the answer remains fresh for N seconds after the answer is generated.",
        "Dyrektywa no-store wskazuje, że jakikolwiek cache dowolnego rodzaju nie powinien przechowywać tej odpowiedzi.": "The no-store directive indicates that any cache of any kind should not store this answer.",
        "Dyrektywa PRIVATE wskazuje, że odpowiedź może być przechowywana wyłącznie w prywatnej pamięci podręcznej (np. lokalnej pamięci przeglądarki).": "Directive PRIVATE indicates that the response may only be stored in private cache (e.g., local browser cache).",
        "Dyrektywa przechowywania": "Storage directive",
        "Dyrektywa PUBLIC wskazuje, że odpowiedź może być przechowywana we współdzielonej pamięci podręcznej (np. proxy).": "Directive PUBLIC indicates that the response may be stored in shared cache (e.g., proxy).",
        "Dyrektywa s-maxage jest ignorowana przez prywatne pamięci podręczne i zastępuje wartość określoną przez dyrektywę max-age dla współdzielonych pamięci podręcznych.": "Directive s-maxage is ignored by private caches and overrides the value specified by the max-age directive for shared caches.",
        "Dyrektywa s-maxage wskazuje, jak długo odpowiedź pozostaje aktualna we współdzielonej pamięci podręcznej (np. proxy).": "Directive s-maxage indicates how long the response remains valid in shared cache (e.g., proxy).",
        "Dyrektywy zakresu": "Range directives",
        "Działania masowe": "Bulk actions",
        "Dzielenie": "Division",
        "dzień": "day",
        "Dzień": "Day",
        "Dzisiaj": "Today",
        "Edycja definicji": "",
        "Edycja dokumentów": "Document edit",
        "Edycja dokumentu": "Document edit",
        "Edycja endpointu": "Endpoint edit",
        "Edycja komponentu": "Component edit",
        "Edycja modułu": "Module edit",
        "Edycja scenariusza": "Scenario edit",
        "Edycja w popupie": "Popup edit",
        "Edycja webhooka": "Webhook edit",
        "Edycja wszystkich dokumentów": "Edit all documents",
        "Edycja źródła danych": "Data source edit",
        "Edytor": "Editor",
        "Edytor lokalizowany": "Localized editor",
        "Edytuj": "Edit",
        "Edytuj dokument": "Edit document",
        "Edytuj punkt": "Edit point",
        "Edytuj wiersz": "Edit row",
        "Edytuj wpis": "Edit entry",
        "Edytuj wydarzenie": "Edit event",
        "Eksport do Excela": "Export to Excel",
        "Eksport dokumentów": "Export documents",
        "Element nadrzędny": "Parent item",
        "Element został usunięty": "Item has been deleted",
        "Email": "Email",
        "Endpoint został dodany.": "Endpoint has been added.",
        "Endpoint został usunięty.": "",
        "Endpoint został zaktualizowany.": "Endpoint has been updated.",
        "Eskportuj": "Export",
        "Etap": "Stage",
        "Etykieta": "Label",
        "Etykiety": "Labels",
        "False": "False",
        "Filmy": "Videos",
        "Filtrowanie": "Filtering",
        "Filtrowanie listy dokumentów": "Document list filtering",
        "Filtry": "Filters",
        "Formularz": "Form",
        "Formularz bazuje na nieaktualnej wersji definicji.": "Form is based on an outdated definition version.",
        "Formularz jest wymagany": "",
        "Formularz został dodany.": "Form has been added.",
        "Formularz został skopiowany.": "Form has been copied.",
        "Formularz został utworzony.": "Form has been created.",
        "Formularz został zaakceptowany.": "Form has been approved.",
        "Formularz został zaktualizowany.": "Form has been updated.",
        "Formularze": "Forms",
        "Formuła jest nieprawidłowa": "Formula is invalid",
        "Funkcjonalności": "Functionalities",
        "GET: Lista wpisów (sortowanie i stronicowanie)": "GET: Entry list (sorting and pagination)",
        "GET: Pobranie danych": "GET: Data retrieval",
        "GET: Pobranie wpisu": "GET: Entry retrieval",
        "GET: Schemat (definicja formularza)": "GET: Schema (form definition)",
        "Grafika wektorowa": "Vector graphics",
        "Harmonogram": "Schedule",
        "Hasło": "Password",
        "Hierarchia": "Hierarchy",
        "Hierarchiczny": "Hierarchical",
        "Historia": "History",
        "i obserwując wynik w oknie konsoli.": "",
        "Id": "Id",
        "Id dokumentu": "",
        "Id encji": "",
        "ID operacji": "Operation ID",
        "ID procesu": "Process ID",
        "Id wpisu": "Entry ID",
        "Ikona": "Icon",
        "Ikona jest wymagana": "",
        "Ilość elementów: %0": "Number of items: %0",
        "Ilość powtórzeń pętli": "",
        "Ilość powtórzeń po wystąpieniu błędu": "Number of retries after error occurrence",
        "Ilość wierszy": "Number of rows",
        "Ilość wyników do odrzucenia": "Number of results to discard",
        "Ilość wyników do pobrania": "Number of results to retrieve",
        "Ilość znaków": "Number of characters",
        "Ilość znaków odpowiedzi": "Number of answer characters",
        "Imię": "First name",
        "Import": "Import",
        "Import modułu": "Module import",
        "Importuj definicję formularza": "Import form definition",
        "Importuj definicję scenariusza": "",
        "Indeksowanie": "Indexing",
        "Info": "Info",
        "Informacja": "Information",
        "input1 < input2": "",
        "Instrukcje": "",
        "Int": "Int",
        "Jasny": "Light",
        "Jedna kolumna": "One column",
        "Język jest wymagany.": "",
        "JSON": "",
        "Kafelki": "Tiles",
        "Kalendarz": "Calendar",
        "Kanał jest wymagany": "",
        "Kategoria": "Category",
        "Kategoria jest wymagana": "Category is required",
        "Kategoria została dodana.": "Category has been added.",
        "Kategoria została usunięta.": "Category has been deleted.",
        "Kategoria została zaktualizowana.": "Category has been updated.",
        "Kategorie": "Categories",
        "Klucz": "Key",
        "Kod pocztowy": "Postal code",
        "Kod walidacji": "Validation code",
        "Kod źródłowy": "Source code",
        "Kolor": "Color",
        "Kolor ikony": "Icon color",
        "Kolumna": "Column",
        "Kolumny": "Columns",
        "Komponent którego wartość zostanie użyta jako nazwa elementu nadrzędnego. Dostępne tylko komponenty typu ``Tekst``.": "Component whose value will be used as the name of the parent item. Only components of type ``Text`` are available.",
        "Komponent relacyjny": "Relational component",
        "Komponent został dodany.": "Component has been added.",
        "Komponent został usunięty.": "Component has been deleted.",
        "Komponent został zaktualizowany.": "Component has been updated.",
        "Komponent źródłowy": "Source component",
        "Komponenty": "Components",
        "Komunikat błędu": "Error message",
        "Komunikat walidacji": "Validation message",
        "Konfiguracja": "Configuration",
        "Konfiguracja kolumn tabeli": "Table column configuration",
        "Konfiguracja listy": "List configuration",
        "Konfiguracja zaawansowana": "Advanced configuration",
        "Konfiguracja zapytania": "Query configuration",
        "Koniec pętli": "",
        "Konstruktor": "",
        "Konta użytkowników": "User accounts",
        "Kontrolka": "Control",
        "Kontrolka dostępna publicznie": "",
        "Kontrolka wyboru (pojedynczy wybór, value jest skrótem pobierającym pierwszy element z tablicy data)": "Selection control (single choice, value is a shortcut retrieving the first element from the data array)",
        "Kontrolka wyboru (wybór wielokrotny)": "Selection control (multiple choice)",
        "Konwertuj obrazy do formatu WebP": "Convert images to WebP format",
        "Kopiuj": "Copy",
        "Kopiuj adres": "Copy address",
        "Kopiuj definicję": "Copy definition",
        "Kraj": "Country",
        "Kreator modułu": "",
        "Krok minut": "Minute step",
        "Krok minut musi być liczbą z zakresu od 1 do 60.": "Minute step must be a number between 1 and 60.",
        "Kroki": "Steps",
        "Krótki opis": "Short description",
        "Liczba": "Number",
        "Liczba całkowita": "Integer",
        "Liczba dziesiętna": "Decimal number",
        "Liczba wyników na stronie": "Number of results per page",
        "Linia": "Line",
        "linie": "lines",
        "Lista elementów zostanie zawężona tylko do tych, które są pozwiązane z wybranymi wartościami z zaznaczonych komponentów.": "Item list will be narrowed down to those related to selected values from marked components.",
        "Lista ID": "ID list",
        "Lista rozszerzeń oddzielona przecinkami.": "List of extensions separated by commas.",
        "Lista rozwijana": "Dropdown list",
        "Lista sortowalna": "Sortable list",
        "Litery": "Letters",
        "Litery i cyfry": "Letters and digits",
        "Logi": "Logs",
        "Lokalizacja": "Location",
        "Lokalizowane": "Localized",
        "Long": "Long",
        "Łączenie treści": "Content merging",
        "Maksimum": "Maximum",
        "Maksymalna ilość plików": "Maximum number of files",
        "Maksymalna rozdzielość obrazu po optymalizacji: %0x%1px": "",
        "Maksymalny rozmiar pliku w MB": "Maximum file size in MB",
        "Maksymalny rozmiar pojedynczego pliku": "Maximum single file size",
        "Małe litery": "Lowercase letters",
        "Małe znaki": "Lowercase characters",
        "Mały": "Small",
        "Mały układ siatki": "Small grid layout",
        "Mapa": "Map",
        "Mapowanie danych": "Data mapping",
        "Mediana": "Median",
        "Metadane dokumentu": "Document metadata",
        "Metoda": "Method",
        "Metoda musi zwracać obiekt \"entry.errors\".": "Method must return an \"entry.errors\" object.",
        "Miejsca po przecinku": "Decimal places",
        "Miejsca publikacji": "Publication locations",
        "Miejscowość": "Locality",
        "miesiąc": "month",
        "Miesiąc": "Month",
        "Minimalna ilość plików": "Minimum number of files",
        "Minimalna szerokość": "Minimum width",
        "Minimapa": "Minimap",
        "Minimum": "Minimum",
        "Mnożenie": "Multiplication",
        "Model danych": "Data model",
        "Model danych i cechy można skonfigurować tylko podczas dodawania nowego formularza.": "Data model and features can only be configured when adding a new form.",
        "module.": "",
        "Moduł": "Module",
        "Moduł będzie skonfigurowany z domyślnymi ustawieniami odpowiednimi do większości zastosowań.": "",
        "Moduł dynamiczny": "Dynamic module",
        "Moduł został dodany.": "Module has been added.",
        "Moduł został usunięty.": "Module has been deleted.",
        "Moduł został wyeksportowany.": "Module has been exported.",
        "Moduł został zaktualizowany.": "Module has been updated.",
        "Moduły": "Modules",
        "Moduły dynamiczne": "",
        "Modyfikacja dokumentów": "Document modification",
        "Modyfikacja dokumentu w module": "",
        "Modyfikacja rekordu w bazie danych": "",
        "Moje dokumenty": "My documents",
        "Moje punkty": "My points",
        "Moje wydarzenia": "My events",
        "Możliwość wielokrotnego wyboru": "Multiple choice",
        "Multimedia": "Multimedia",
        "multipart/form-data": "multipart/form-data",
        "Na wejściu należy podać dane wejściowe, a następnie zadeklarować": "",
        "Na wyjściu zwracana jest encja wybranego modelu danych.": "",
        "Na wyjściu zwracany jest model wpisu wybranego formularza dynamicznego.": "",
        "Nadawanie uprawnień do dokumentów": "Granting privileges to documents",
        "Nadawanie uprawnień do własnych dokumentów": "Granting privileges to own documents",
        "Nadawanie uprawnień do wszystkich dokumentów": "Granting privileges to all documents",
        "Nagłówek": "Header",
        "Nagłówki cache": "Cache headers",
        "Należy wybrać model danych.": "",
        "Należy wybrać przynajmniej jedną akcję.": "",
        "Należy wybrać przynajmniej jedną właściwość modelu.": "",
        "Należy zapisać zmiany w scenariuszu przed uruchomieniem procesu.": "",
        "Następny": "Next",
        "Nazwa": "Name",
        "Nazwa akcji": "Action name",
        "Nazwa etapu": "Stage name",
        "Nazwa formularza": "Form name",
        "Nazwa jest wymagana": "Name is required",
        "Nazwa kategorii": "",
        "Nazwa kolumny": "Column name",
        "Nazwa kolumny z obrazem": "",
        "Nazwa kolumny z opisem": "Column name with description",
        "Nazwa kolumny z wartością": "Column name with value",
        "Nazwa komponentu": "Component name",
        "Nazwa modelu": "Model name",
        "Nazwa modułu": "Module name",
        "Nazwa musi mieć co najmniej 3 znaki": "Name must have at least 3 characters",
        "Nazwa musi mieć co najmniej 4 znaki": "",
        "Nazwa nie może być dłuższa niż 30 znaków": "Name cannot exceed 30 characters",
        "Nazwa nie może być dłuższy niż 50 znaków": "Name cannot exceed 50 characters",
        "Nazwa operacji": "Operation name",
        "Nazwa pola jest wymagana": "",
        "Nazwa przycisku ``Dalej``": "Button name ``Next``",
        "Nazwa przycisku ``Wstecz``": "Button name ``Back``",
        "Nazwa przycisku ``Wyślij``": "Button name ``Send``",
        "Nazwa scenariusza": "Scenario name",
        "Nazwa sekcji w menu": "Menu section name",
        "Nazwa sekcji...": "Section name...",
        "Nazwa techniczna": "Technical name",
        "Nazwa warunku jest wymagana": "",
        "Nazwa warunku musi być unikalna": "",
        "Nazwa warunku musi się zaczynać od małej litery i może zawierać tylko znaki alfanumeryczne": "",
        "nazwa warunku...": "",
        "Nazwa webhooka": "Webhook name",
        "Nazwa wyświetlana": "Display name",
        "Nazwa zdarzenia": "",
        "Nazwa zmiennej jest wymagana": "Variable name is required",
        "Nazwa zmiennej musi być unikalna": "Variable name must be unique",
        "nazwa zmiennej...": "variable name...",
        "Nazwa źródła": "Source name",
        "Nazwa źródła danych": "Data source name",
        "Nazwisko": "Last name",
        "Nazwy wartości": "Value names",
        "Nazwy właściwości modelu": "",
        "Nie": "No",
        "Nie dotyczy plików svg": "",
        "Nie masz dostępu do tego modułu": "You do not have access to this module",
        "Nie masz uprawnień do tego dokumentu": "You do not have privileges to this document",
        "Nie można tworzyć zapętlonych powiązań.": "Cannot create circular references.",
        "Nie można zapisać zmian ponieważ skrypt się nie kompiluje.": "Cannot save changes because the script does not compile.",
        "Nie podano wymaganej ilości znaków: %0.": "Required number of characters not provided: %0.",
        "Nie podano wymaganej ilości znaków: %0. (%1)": "Required number of characters not provided: %0. (%1)",
        "Nie udało się pobrać ustawień kont użytkowników": "",
        "Nie udało się uruchomić procesu.": "",
        "Nie wybrano użytkownika.": "",
        "Nie znaleziono formularza.": "No form found.",
        "Nieaktywny": "Inactive",
        "Niepoprawne wyrażenie regularne": "Invalid regular expression",
        "Nieprawidłowa definicja": "Invalid definition",
        "Niestandardowe logo i stopka": "",
        "Niestandardowy błąd": "Custom error",
        "Niewidoczne": "Invisible",
        "Nigdy": "Never",
        "no-store (wyłącza cache)": "no-store (disables cache)",
        "Nowa data": "New date",
        "Nowa lokalizacja": "New location",
        "Nowa wartość": "New value",
        "Numer domu": "House number",
        "Numer mieszkania": "Apartment number",
        "Obiekt JSON": "",
        "Obok siebie": "Side by side",
        "Obsługiwane kanały": "",
        "Obsługiwane powiadomienia": "",
        "Obsługiwane są wszystkie powiadomienia.": "",
        "od": "from",
        "Od": "From",
        "od %0": "from %0",
        "Odejmowanie": "Subtraction",
        "Odpowiedzi": "Answers",
        "Odpowiedzi: %0 na %1": "Answers: %0 out of %1",
        "Odpowiedź dowolna": "Any answer",
        "Odstęp": "Spacing",
        "Omnitool": "Omnitool",
        "Opcje": "Options",
        "Operacje": "Operations",
        "Operacje w pętli": "",
        "Operacje wykonane": "Operations performed",
        "Opis": "Description",
        "Opis błędu": "Error description",
        "Opis źródła": "Source description",
        "Optymalizuj rozdzielczość obrazów": "Optimize image resolution",
        "Ostrzeżenie": "Warning",
        "Parametry wejściowe pochodzą z innych podpiętych widgetów.": "",
        "Parametry wejściowe skryptu": "Script input parameters",
        "Parametry, wymagane do wykonania zapytania:": "Parameters required to execute the query:",
        "Parser Liquid": "",
        "Pasek": "Bar",
        "Pasek postępu": "Progress bar",
        "Pełna kontrola nad wszystkimi ustawieniami modułu oraz endpointami API.": "",
        "Pełna treść wiadomości": "",
        "Pełny": "Full",
        "Pełny dokument": "",
        "Pierwiastkowanie wartości kolumny": "Column value square root",
        "Pigułki": "Pills",
        "Placeholder": "Placeholder",
        "Pliki": "Files",
        "Pliki: %0": "Files: %0",
        "Po": "After",
        "po elementach kolekcji": "",
        "Pobieranie dokumentów": "",
        "Pobieranie encji": "",
        "Pobieranie i aktualizacja encji": "",
        "Pobieranie i usuwanie encji": "",
        "Początek pętli": "",
        "Początkowa ilość wierszy": "Initial number of rows",
        "Podaj ID dokumentu lub nazwę parametru wejściowego.": "",
        "Podaj nazwę formularza": "Enter form name",
        "Podaj nazwę scenariusza": "Enter scenario name",
        "Podaj nową nazwę": "Enter new name",
        "Podajemy go w formie jednoliniowej. Przykład:": "",
        "Podana nazwa jest zajęta.": "Provided name is taken.",
        "Podana wartość jest nieprawidłowa.": "Provided value is invalid.",
        "Podane ręcznie": "",
        "Podanie nazwy jest wymagane.": "Providing a name is required.",
        "Podano adres": "Address provided",
        "Podano nieprawidłowe dane": "Invalid data provided",
        "Podano nieprawidłowe dane.": "Invalid data provided.",
        "Podano nieprawidłowe dane. (%0)": "Invalid data provided. (%0)",
        "Podgląd": "Preview",
        "Podgląd formularza": "Form preview",
        "Podgląd listy": "List preview",
        "Podgląd tabeli": "Table preview",
        "Podgląd wyniku jest niedostępny. Aby zobaczyć podgląd, scenariusz musi się wykonać poprawnie przynajmniej jeden raz.": "",
        "Podgląd wyniku wybranego etapu": "",
        "Podkreślenie": "Underline",
        "Podpis": "Signature",
        "Podproces": "",
        "Podstawowe": "Basic",
        "Podstawowe operacje na datach": "Basic date operations",
        "Podstawowe operacje na liczbach": "Basic number operations",
        "Podstawowe operacje tekstowe": "Basic text operations",
        "Podstawowe operacje warunkowe": "Basic conditional operations",
        "Pojedynczy formularz": "Single form",
        "Pojedynczy wybór": "Single choice",
        "Pokaż etykietę": "Show label",
        "Pokaż numery stron": "Show page numbers",
        "Pokaż numery tygodnia na kalendarzu": "Show week numbers on calendar",
        "Pokaż przycisk ``Wyślij``": "Show ``Send`` button",
        "Pokaż starsze wersje": "Show older versions",
        "Pokaż tytuł formularza": "Show form title",
        "Pokaż tytuł sekcji": "Show section title",
        "Pokaż tytuł strony": "Show page title",
        "Pokaż tytuły stron": "Show page titles",
        "pokaż więcej...": "show more...",
        "Pola": "",
        "Pole": "Field",
        "Pole \"%0\" jest wymagane.": "Field \"%0\" is required.",
        "Pole \"%0\" jest wymagane. (%1)": "Field \"%0\" is required. (%1)",
        "Pole \"%0\" nie zawiera prawidłowego adresu email.": "Field \"%0\" does not contain a valid email address.",
        "Pole \"%0\" nie zawiera prawidłowego adresu URL.": "Field \"%0\" does not contain a valid URL.",
        "Pole \"%0\" wymaga uzupełnienia wszystkich elementów": "Field \"%0\" requires all elements to be completed",
        "Pole \"%0\" zawiera niedozwoloną wartość.": "Field \"%0\" contains a disallowed value.",
        "Pole \"%0\" zawiera nieprawidłowy symbol.": "Field \"%0\" contains an invalid symbol.",
        "Pole \"Akcje\" jest wymagane.": "",
        "Pole \"Drugie imię\" jest wymagane.": "Field \"Middle name\" is required.",
        "Pole \"Id dokumentu\" jest wymagane.": "",
        "Pole \"Id encji\" jest wymagane.": "",
        "Pole \"Imię\" jest wymagane.": "Field \"First name\" is required.",
        "Pole \"Liczba wyników na stronie\" jest wymagane.": "Field \"Number of results per page\" is required.",
        "Pole \"Model\" jest wymagane.": "",
        "Pole \"Moduł dynamiczny\" jest wymagane.": "Field \"Dynamic module\" is required.",
        "Pole \"Moduł\" jest wymagane.": "",
        "Pole \"Nazwa modelu\" jest wymagane.": "",
        "Pole \"Nazwisko\" jest wymagane.": "Field \"Last name\" is required.",
        "Pole \"Podproces\" jest wymagane.": "",
        "Pole \"Pole\" jest wymagane.": "Field \"Field\" is required.",
        "Pole \"Sekcja modułu\" jest wymagane.": "Field \"Module section\" is required.",
        "Pole \"Sekcja\" jest wymagane.": "",
        "Pole \"Typ agregacji\" jest wymagane.": "Field \"Aggregation type\" is required.",
        "Pole \"Tytuł\" jest wymagane.": "Field \"Title\" is required.",
        "Pole \"Wyrażenie EQL\" jest wymagane.": "",
        "Pole jest wymagane": "Field is required",
        "Pole może zawierać jedynie cyfry.": "Field can only contain digits.",
        "Pole może zawierać jedynie cyfry. (%0)": "Field can only contain digits. (%0)",
        "Pole może zawierać jedynie litery i cyfry.": "Field can only contain letters and digits.",
        "Pole może zawierać jedynie litery i cyfry. (%0)": "Field can only contain letters and digits. (%0)",
        "Pole może zawierać jedynie litery.": "Field can only contain letters.",
        "Pole może zawierać jedynie litery. (%0)": "Field can only contain letters. (%0)",
        "Pole może zawierać tylko ciało metody walidującej dane w postaci natywnego kodu JavaScript.": "Field can only contain the body of a data validation method in native JavaScript code.",
        "Pole typu \"%0\" jest niedozwolone w tym formularzu.": "Field type \"%0\" is not allowed in this form.",
        "Pole wymaga podania przynajmniej jednego znaku specjalnego.": "Field requires at least one special character.",
        "Pole wymaga podania przynajmniej jednej cyfry.": "Field requires at least one digit.",
        "Pole wymaga podania przynajmniej jednej dużej litery.": "Field requires at least one uppercase letter.",
        "Pole wymaga podania przynajmniej jednej małej litery.": "Field requires at least one lowercase letter.",
        "Pole wymagane": "Required field",
        "Pole zawiera": "Field contains",
        "Pomoc": "Help",
        "Poprawne": "Correct",
        "Poprawność kompilacji skryptu można przetestować, wciskając przycisk": "",
        "Poprawny": "Valid",
        "Poprzedni": "Previous",
        "Poprzednia lokalizacja": "Previous location",
        "Porównaj %0": "Compare %0",
        "Porównaj wersje": "Compare versions",
        "Porównania": "Comparisons",
        "Porównanie": "Comparison",
        "Porównanie wersji": "Version comparison",
        "Porównywana wersja": "Compared version",
        "POST: Dowolne wyszukiwanie (Zapytanie EQL)": "POST: Any search (EQL Query)",
        "POST: Upload załączników": "POST: Upload attachments",
        "POST: Utworzenie wpisu": "POST: Create entry",
        "POST: Zapisanie zmian": "POST: Save changes",
        "Potwierdzenie usunięcia": "Delete confirmation",
        "Potwierdź akceptację": "Confirm approval",
        "Potwierdź usunięcie": "Confirm deletion",
        "Powiadomienia": "",
        "Powiadomienie jest wymagane": "",
        "Powiadomienie systemowe": "",
        "Powiązana kontrolka": "Linked control",
        "Powiększ": "Enlarge",
        "Powinno się dodać dyrektywę PRIVATE dla treści personalizowanych dla użytkownika, zwłaszcza dla odpowiedzi otrzymywanych po zalogowaniu i z uwzględnieniem uprawnień.": "PRIVATE directive should be added for user-personalized content, especially for responses received after login and considering privileges.",
        "Powrót": "Back",
        "Powtórzenia": "Repetitions",
        "Powyższe obiekty zawierają tylko właściwości i są pozbawione wszystkich metod.": "The above objects contain only properties and lack all methods.",
        "Poziom dostępu do webhooka": "Webhook access level",
        "Poziom dostępu użytkownika": "User access level",
        "pozwala na wykorzystanie zaawansowanego edytora tekstu.": "",
        "Pozwól na dodawanie wierszy": "Allow adding rows",
        "Pozwól na sortowanie wierszy": "Allow sorting rows",
        "Pozycja na liście": "Position on list",
        "Pozycje zostały zapisane.": "Positions have been saved.",
        "pół roku": "half a year",
        "Prezentacja": "Presentation",
        "private (tylko cache przeglądarki)": "private (browser cache only)",
        "Procent": "Percent",
        "Proces": "Process",
        "Proces został uruchomiony.": "",
        "Projekt": "Project",
        "Proste uprawnienia": "Simple privileges",
        "Przed": "Before",
        "Przedrostek": "Prefix",
        "Przejdź do kolejnego kroku gdy:": "Proceed to the next step when:",
        "Przekroczono dozwoloną ilość znaków: %0.": "Exceeded allowed number of characters: %0.",
        "Przekroczono dozwoloną ilość znaków: %0. (%1)": "Exceeded allowed number of characters: %0. (%1)",
        "Przełącznik": "Switch",
        "Przeniesienie wpisu do kosza": "Move entry to bin",
        "Przeniesione": "Moved",
        "Przeniesiono": "Moved",
        "Przenieś niżej": "Move down",
        "Przenieś wyżej": "Move up",
        "Przerwany": "Interrupted",
        "Przesuń do góry": "Move up",
        "Przesuń na dół": "Move down",
        "Przybliżenie": "Zoom",
        "Przybornik": "Toolkit",
        "Przykład:": "Example:",
        "Przykładowa struktura danych": "Sample data structure",
        "Przykłady": "Examples",
        "Przykłady konfiguracji": "Configuration examples",
        "przypisz wynik etapu...": "assign stage result...",
        "Przyrostek": "Suffix",
        "Przywrócenie wpisu z kosza": "Restore entry from bin",
        "public (cache przeglądarki i proxy)": "public (browser and proxy cache)",
        "PUT: Aktualizacja wpisu": "PUT: Update entry",
        "Pytania": "Questions",
        "Query string": "Query string",
        "Radio": "Radio",
        "Reaguj na zmiany wybranych właściwości": "",
        "Reguła walidacji": "Validation rule",
        "Relacyjne": "Relational",
        "Renderer MJML": "",
        "Request body": "Request body",
        "Rest API": "",
        "RESTful API": "RESTful API",
        "Rezultat": "Result",
        "Ręczne uruchomienie": "",
        "Rodzaj odpowiedzi": "Response type",
        "Rodzaj pętli": "",
        "Rodzaj zwracanego wyniku": "",
        "rok": "year",
        "Rok": "Year",
        "Rozmiar okna popup": "Popup window size",
        "Rozmiar podawany w bajtach.": "Size provided in bytes.",
        "Rozmieść równomiernie": "Distribute evenly",
        "Równość": "Equality",
        "Satysfakcja": "Satisfaction",
        "Scenariusz": "Scenario",
        "Scenariusz aktywny": "Active scenario",
        "Scenariusz jest aktywowany po wywołaniu wybranego Webhooka.": "",
        "Scenariusz jest aktywowany po wywołaniu wybranego zdarzenia.": "",
        "Scenariusz jest aktywowany według wybranego hamonogramu.": "",
        "Scenariusz nie jest aktywny": "",
        "Scenariusz został dodany.": "Scenario has been added.",
        "Scenariusz został usunięty.": "Scenario has been deleted.",
        "Scenariusz został utworzony.": "Scenario has been created.",
        "Scenariusz został zaktualizowany.": "Scenario has been updated.",
        "Scrollowalne okna popup": "Scrollable popup windows",
        "Sekcja": "Section",
        "Sekcja lokalizowana": "",
        "Sekcja modułu": "Module section",
        "Sekcja powtarzalna": "",
        "Selektor ikony": "Icon selector",
        "Selektor kolorów": "Color selector",
        "Server Side Cache": "Server Side Cache",
        "Skala 1-5": "Scale 1-5",
        "Skrypt (C#)": "Script (C#)",
        "słowa": "words",
        "Słownik": "Dictionary",
        "Sortowanie": "Sorting",
        "Sparametryzowane": "",
        "Specjalizowane": "Specialized",
        "Specyfikacja": "Specification",
        "Sposób dystrybucji": "",
        "Sposób prezentacji zakładek": "Tab presentation method",
        "Sprawdzenie czy pusty": "Check if empty",
        "Stała wartość": "Constant value",
        "Stan": "State",
        "Standardowe uprawnienia": "Standard privileges",
        "Standardowy": "Standard",
        "Start": "",
        "Status": "Status",
        "Status dokumentu został zmieniony.": "Document status has been changed.",
        "Status modułu": "Module status",
        "Status webhooka": "Webhook status",
        "Status żądania": "Request status",
        "string": "",
        "String": "String",
        "Strona": "Page",
        "Strona %0": "Page %0",
        "Studio": "Studio",
        "Stwierdzenie": "Statement",
        "Styl": "Style",
        "Sukces": "Success",
        "Suma": "Sum",
        "Switch": "",
        "Sygnatura dokumentu": "",
        "Symbol": "Symbol",
        "Symbol jest wymagany": "Symbol is required",
        "Symbol jest zajęty": "Symbol is taken",
        "Symbol modułu": "Module symbol",
        "Symbol może składać się tylko z małych liter, cyfr oraz znaku - ": "Symbol can only consist of lowercase letters, digits, and the - character",
        "Symbol musi mieć co najmniej 3 znaki": "Symbol must have at least 3 characters",
        "Symbol musi mieć co najmniej 4 znaki": "",
        "Symbol nie może być dłuższy niż 10 znaków": "Symbol cannot exceed 10 characters",
        "Symbol nie może być dłuższy niż 20 znaków": "Symbol cannot exceed 20 characters",
        "Symbol w adresie URL": "Symbol in URL",
        "Synchronizuj": "Synchronize",
        "System": "System",
        "Szablon email": "",
        "Szablon modułu": "Module template",
        "Szablon wiadomości email": "",
        "Szablony definiowane są w ": "",
        "Szczegóły": "Details",
        "Szerokość": "Width",
        "Szerokość geograficzna": "Latitude",
        "Średni": "Average",
        "Średnia": "Average",
        "Tabela": "Table",
        "Tak": "Yes",
        "Tak/Nie": "Yes/No",
        "Tekst": "Text",
        "Tekst lokalizowany": "Localized text",
        "Tekst zastępczy": "Placeholder text",
        "Telefon": "Phone",
        "Teraz": "Now",
        "Test": "",
        "Testuj": "",
        "Testuj zapytanie": "Test query",
        "Treści odpowiedzi są wymagane": "Response content is required",
        "Treści pytań są wymagane": "Question content is required",
        "Treść": "Content",
        "True": "True",
        "Trwa porównywanie wersji...": "Comparing versions...",
        "Tryb prezentacyjny": "Presentation mode",
        "Trzy kolumny": "Three columns",
        "Tworzenie dokumentów": "Document creation",
        "Tworzenie dokumentu": "",
        "Tworzenie encji": "",
        "tydzień": "week",
        "Tydzień": "Week",
        "Tylko do odczytu": "Read only",
        "Typ agregacji": "Aggregation type",
        "Typ kontentu": "Content type",
        "Typ odbiorcy": "",
        "Typ pola": "Field type",
        "Typ zmiennej": "Variable type",
        "Tytuł": "Title",
        "Tytuł formularza jest wymagany": "Form title is required",
        "Tytuł formularza nie może być dłuższy niż %0 znaków": "Form title cannot exceed %0 characters",
        "Tytuł sekcji": "Section title",
        "Układ": "Layout",
        "Ukryta": "Hidden",
        "Ukryty": "Hidden",
        "Ulica": "Street",
        "Uprawnienia": "Privileges",
        "Uprawnienia do dokumentów": "Document privileges",
        "Url": "Url",
        "Uruchom proces": "",
        "Uruchomienie harmonogramu": "",
        "Uruchomienie podprocesu": "",
        "Uruchomienie procesu": "",
        "Ustaw szerokości proporcjonalnie": "Set proportional widths",
        "Ustawienia": "Settings",
        "Ustawienia formularza": "Form settings",
        "Ustawienia zostały zapisane.": "Settings have been saved.",
        "Usunięcie dokumentu": "Document removal",
        "Usunięcie formularzannOperacja jest nieodwracalna. Zostaną utracone wszystkie powiązane dokumenty!nCzy na pewno chcesz usunąć wybrany formularz?": "",
        "Usunięcie wpisu": "Entry removal",
        "Usunięta wartość": "Removed value",
        "Usunięte": "Removed",
        "Usunięto": "Removed",
        "Usuń": "Delete",
        "Usuń dokument": "Delete document",
        "Usuń grupę": "Delete group",
        "Usuń logi gdy wykonywanie scenariusza": "Delete logs when executing scenario",
        "Wyślij powiadomienie gdy wykonywanie scenariusza": "Send a notification when executing scenario",
        "Usuń parametr": "Delete parameter",
        "Usuń pole": "",
        "Usuń pozycję": "Delete item",
        "Usuń punkt": "Delete point",
        "Usuń sekcję": "Delete section",
        "Usuń spacje": "Delete spaces",
        "Usuń warunek": "",
        "Usuń wydarzenie": "Delete event",
        "Usuwanie dokumentów": "Document deletion",
        "Usuwanie encji": "",
        "Usuwanie własnych dokumentów": "Deleting own documents",
        "Usuwanie wszystkich dokumentów": "Deleting all documents",
        "Utworzenie wpisu": "Entry creation",
        "Utwórz formularz": "Create form",
        "Utwórz kopię formularza": "Create form copy",
        "Utwórz kopię z": "Create copy from",
        "Utwórz scenariusz": "Create scenario",
        "UWAGA: Brak obsługi TypeScript oraz w kodzie metody nie można robić importów.": "WARNING: No TypeScript support and method code cannot include imports.",
        "Użyj domyślnego zapytania SQL": "Use default SQL query",
        "Użytkownik": "",
        "W widgetu zmiennej możliwe jest zdefiniowanie wartości dla jednego z podstawowych typów danych, do wykorzystania w dalszej części procesu.": "",
        "W ciele metody walidującej dostępne są poniższe zmienne:": "The following variables are available in the validation method body:",
        "W przyszłości": "In the future",
        "w wyznaczonym zakresie": "",
        "W zapytaniu można używać nazw zmiennych z parametrów wejściowych skryptu, np.:": "",
        "Walidacja": "Validation",
        "Walidacja danych": "Data validation",
        "Walidacja po stronie API": "API-side validation",
        "Walidacja typów MIME": "MIME type validation",
        "Wariant powiadomienia": "",
        "Wartośc pola jest wymagana": "",
        "Wartość domyślna": "Default value",
        "Wartość warunku jest wymagana": "",
        "Wartość zmiennej": "Variable value",
        "Warunek": "Condition",
        "Warunek jest zdefiniowany przy użyciu wyrażenia lambda w C#. Przykład:": "",
        "Warunek nie zostanie spełniony": "Condition will not be met",
        "Warunek tylko do odczytu": "Read-only condition",
        "Warunek widoczności": "Visibility condition",
        "Warunek wymagania": "Required condition",
        "Warunek zostanie spełniony": "Condition will be met",
        "Warunki": "",
        "Warunki logiczne": "Logical conditions",
        "Warunkowo": "Conditionally",
        "Ważność": "Validity",
        "Webhook": "Webhook",
        "Webhook został dodany.": "Webhook has been added.",
        "Webhook został usunięty.": "Webhook has been deleted.",
        "Webhook został zaktualizowany.": "Webhook has been updated.",
        "Webhooki": "Webhooks",
        "Wersja bazowa": "Base version",
        "Wersja porównywana": "Compared version",
        "Wersje": "Versions",
        "wersji zaakceptowanej": "accepted version",
        "Wersjonowany": "Versioned",
        "Wewnętrznie": "Internally",
        "Widoczność": "Visibility",
        "Widoczność modułu w menu": "Module visibility in menu",
        "Widoczność sekcji w menu modułu": "Section visibility in module menu",
        "Wielkość kroku": "Step size",
        "Wielokrotny wybór": "Multiple choice",
        "Wiersz": "Row",
        "Wiersz %0": "Row %0",
        "więcej...": "more...",
        "Więcej...": "More...",
        "Wklej komponent": "Paste component",
        "Właściwości": "Properties",
        "Właściwości szablonu": "Template properties",
        "Włącz": "Enable",
        "Włącz tryb zaawansowany": "",
        "Włącz walidację po stronie API": "Enable API-side validation",
        "Włącza bardzo restrykcyjne sprawdzanie typów MIME dla wysyłanych plików. W przypadku zgłaszania błędów dla plików, których zawartości jesteśmy pewni, należy tą opcję pozostawić nieaktywną.": "Enables very strict MIME type checking for uploaded files. If errors are reported for files whose content is certain, this option should remain inactive.",
        "Włączone": "Enabled",
        "Województwo": "Province",
        "Wpis został dodany.": "Entry has been added.",
        "Wpis został usunięty": "Entry has been deleted",
        "Wpis został usunięty.": "Entry has been deleted.",
        "Wpis został zaakceptowany.": "Entry has been accepted.",
        "Wpis został zaktualizowany.": "Entry has been updated.",
        "Wskazuje, jak długo odpowiedź pozostaje aktualna w pamięci serwera Redis.": "Indicates how long the answer remains valid in Redis server memory.",
        "Wstaw kontrolkę": "Insert control",
        "Wstaw stronę": "Insert page",
        "Wstaw z dołu": "Insert from bottom",
        "Wstaw z góry": "Insert from top",
        "Wstaw z lewej strony": "Insert from left side",
        "Wstaw z prawej strony": "Insert from right side",
        "Wstecz": "Back",
        "Wszystkie": "All",
        "Wybierz formularz zawierający dodatkowe pola dla kont użytkownków": "Select form containing additional fields for user accounts",
        "Wybierz moduł aby dodać sekcję lub nie wybieraj nic aby dodać nowy moduł": "",
        "wybierz moduł...": "",
        "wybierz sekcję...": "",
        "wybierz...": "select...",
        "Wybór": "Choice",
        "Wybór języka": "",
        "Wybór wpływa na kolor szablonu.": "",
        "Wybór wpływa tylko na treść stopki.": "",
        "Wybór+": "Choice+",
        "Wybrana data jest mniejsza niż dozwolona %0.": "Selected date is less than allowed %0.",
        "Wybrana data jest większa niż dozwolona %0.": "Selected date is greater than allowed %0.",
        "Wybrana liczba jest mniejsza niż dozwolona %0.": "Selected number is less than allowed %0.",
        "Wybrana liczba jest większa niż dozwolona %0.": "Selected number is greater than allowed %0.",
        "Wybrane": "",
        "Wybrane dokumenty": "Selected documents",
        "Wybrane: %0": "Selected: %0",
        "Wybranie przynajmniej jednego pola do aktualizacji jest wymagane.": "",
        "Wybranie przynajmniej jednego warunku jest wymagane.": "",
        "Wybrany użytkownik": "",
        "Wyczyść": "Clear",
        "Wykonuje się": "Executing",
        "Wyłączone": "Disabled",
        "Wyłuskaj dane do wybranej właściwości poprzez wyrażenie w formacie języka C#. Albo zostaw pole puste, wtedy zostanie zwrócony cały wynik.": "",
        "Wymaga autoryzacji": "Requires authorization",
        "Wymagane": "Required",
        "Wymagane jest wybranie formularza": "Selecting form is required",
        "Wymagane jest wybranie kategorii": "Selecting category is required",
        "Wymagane jest wybranie komponentu": "Selecting component is required",
        "Wymagane jest wybranie modułu": "Selecting module is required",
        "Wymagane jest wybranie sekcji": "Selecting section is required",
        "Wymagane jest wybranie źródła": "Selecting source is required",
        "Wymagane jest wybranie źródła danych": "Selecting data source is required",
        "Wymagane znaki": "Required characters",
        "Wynik": "Result",
        "Wynik etapu (JSON)": "",
        "Wynik etapu jest wymagany": "Stage result is required",
        "Wynik testu": "Test result",
        "Wyniki testu zawszę będą ograniczone do maksymalnie 10 pozycji.": "Test results will always be limited to a maximum of 10 items.",
        "Wyrażenia warunkowe": "Conditional expressions",
        "Wyrażenie EQL": "",
        "Wyrażenie jest prawidłowe. Udało się pobrać wartość z wyniku.": "",
        "Wyrażenie nie jest prawidłowe. Nie udało się pobrać wartości z wyniku.": "",
        "Wyrażenie regularne": "Regular expression",
        "Wyrażenie w postaci \"/pattern/flag\" nie jest obsługiwane, użyj same wartości pattern": "Expression in form \"/pattern/flag\" is not supported, use pattern value only",
        "Wysłanie emaila": "",
        "Wysłanie powiadomień": "",
        "Wystąpił błąd podczas próby importu definicji modułu.": "Error occurred during module definition import attempt.",
        "Wystąpił nieokreślony problem.": "",
        "Wyszukiwany ciąg znaków": "Search string",
        "Wyślij": "Send",
        "Wyświetlanie dokumentów": "Document display",
        "Wytnij": "Cut",
        "Wywołanie powiadomienia": "",
        "Wywołanie webhooka": "",
        "Wywołanie zdarzenia": "",
        "Wyzwalacze": "Triggers",
        "Wzorzec": "Pattern",
        "Z uprawnieniami": "With privileges",
        "Z uprawnieniami do modułu": "With module privileges",
        "Zaawansowane uprawnienia": "Advanced privileges",
        "Zaawansowany edytor tekstu": "Advanced text editor",
        "Zachowaj oryginalny format obrazów": "Preserve original image format",
        "zacznij pisać aby wyszukać szablon...": "",
        "zacznij pisać aby wyszukać użytkownika...": "start typing to search user...",
        "Zacznij pisać Form lub Entry aby uruchomić podpowiadanie.": "Start typing Form or Entry to trigger suggestions.",
        "Zaczyna sie od": "Starts with",
        "Zagrożenie": "Threat",
        "Zaimportowano definicję modułu.": "Module definition has been imported.",
        "Zakładki": "Bookmarks",
        "Zakończ edycje": "Finish edit",
        "Zakończony": "Finished",
        "zakończy się porażką": "will end in failure",
        "zakończy się sukcesem": "will end successfully",
        "Zakres": "Range",
        "Zakres czasu": "Time range",
        "Zaktualizuj formularz": "Update form",
        "Zaktualizuj najnowszą wersję dokumentu": "Update latest document version",
        "Zależna od kontrolki": "Dependent on control",
        "Zalogowany": "Logged in",
        "Załączniki": "Attachments",
        "Zamień wersje": "Swap versions",
        "Zamknij": "Close",
        "Zaokrąglenie": "Rounding",
        "Zapisz": "Save",
        "Zapisz i wróć": "Save and back",
        "Zapisz i zamknij": "Save and close",
        "Zapisz kategorię": "",
        "Zapisz pozycje": "Save positions",
        "Zapisz zmiany": "Save changes",
        "Zapytanie SQL do pobrania po ID": "SQL query to fetch by ID",
        "Zapytanie SQL do wyszukiwania": "SQL query for search",
        "Zasięg": "Range",
        "Zawiera": "Contains",
        "Zawsze": "Always",
        "Zdecyduj czy scenariusz ma obsługiwać wczystkie czy tylko wybrane kanały.": "",
        "Zdecyduj czy scenariusz ma obsługiwać wczystkie czy tylko wybrane powiadomienia.": "",
        "Zdjęcia": "Photos",
        "Zdjęcie": "Photo",
        "Zgoda": "Consent",
        "Zliczanie": "Counting",
        "Zmiany": "Changes",
        "Zmiany zostały zapisane.": "Changes have been saved.",
        "Zmienione": "Changed",
        "Zmieniono": "Changed",
        "Zmienna": "Variable",
        "Zmienna musi się zaczynać od małej litery i może zawierać tylko znaki alfanumeryczne": "Variable must start with lowercase letter and can contain only alphanumeric characters",
        "Zmniejsz": "Reduce",
        "znaki": "characters",
        "Znaki specialne": "Special characters",
        "Zostaną zaktualizowane definicje wszystkich dokumentów.": "Definitions of all documents will be updated.",
        "Źródła danych": "Data sources",
        "Źródło danych": "Data source",
        "źródło danych zostało dodane.": "data source has been added.",
        "Źródło danych zostało zaktualizowane.": "Data source has been updated.",
        "źródło zostało usunięte.": "source has been deleted.",
        "Żródło danych": "Data source"
    }
};
